import List from "@magalu/ecomm-components/components/List";
import { useRouter } from "@magalu/rave/router";
import { useEvents } from "@magalu/ravejs-event-layer";
import React from "react";

import { ListItemProps } from "./ListItem.types";

const ListItem = ({ events, ...props }: ListItemProps) => {
  const { publish } = useEvents();
  const router = useRouter();
  const { href } = props;

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();

    if (events) {
      events.forEach(({ eventArgs, eventName }) => {
        /* istanbul ignore else */
        if (eventName)
          publish(eventName, { value: { ...(eventArgs?.value || {}) } });
      });
    }
    /* istanbul ignore else */
    if (href) router.push(href, { spa: !!props?.spa });
  };

  return <List.Item onClick={handleClick} {...props} />;
};

export default ListItem;
